import { Link } from "react-router-dom";
import {
  MoreHorizontal,
  Eye,
  Mail,
  Phone,
  Star,
  Edit,
  Trash2,
} from "lucide-react";

export default function ClientsTableRow({
  client,
  openMenuId,
  setOpenMenuId,
  onDelete,
  canDelete,
}) {
  return (
    <tr className="border-b border-gray-100 hover:bg-gray-50 transition">
      <td className="px-3 py-3 font-medium text-gray-900">{client.name}</td>
      <td className="px-3 py-3 text-gray-700">
        <div className="flex items-center gap-2 text-xs">
          <Mail className="w-3.5 h-3.5 text-gray-500" />
          <span>{client.email}</span>
        </div>
        <div className="flex items-center gap-2 text-xs mt-1">
          <Phone className="w-3.5 h-3.5 text-gray-500" />
          <span>{client.phone}</span>
        </div>
      </td>
      <td className="px-3 py-3 text-gray-700">{client.fullAddress}</td>
      <td className="px-3 py-3">
        <span
          className={`px-2.5 py-1 rounded-full text-xs font-medium ${client.tag === "Corporate"
            ? "bg-purple-100 text-purple-700"
            : "bg-blue-100 text-blue-700"
            }`}
        >
          {client.tag}
        </span>
      </td>
      <td className="px-3 py-3">
        {client.averageRating !== null && client.averageRating !== undefined ? (
          <div className="flex items-center gap-1.5">
            <Star className="w-4 h-4 text-yellow-500 fill-yellow-500" />
            <span className="font-medium text-gray-900">
              {client.averageRating.toFixed(1)}
            </span>
          </div>
        ) : (
          <span className="text-gray-400 text-xs">N/A</span>
        )}
      </td>
      {/* <td className="px-3 py-3">
                <span className={`px-2.5 py-1 rounded-full text-xs font-semibold ${client.status === 'Active' ? 'bg-emerald-100 text-emerald-700' : 'bg-yellow-100 text-yellow-700'}`}>
                    {client.status}
                </span>
            </td> */}
      {/* <td className="px-3 py-3 text-gray-600">{client.lastActivity}</td> */}
      <td className="px-3 py-3">
        <div className="flex items-center justify-end">
          {openMenuId === client.id && (
            <div className="flex items-center bg-white rounded-lg shadow-md border border-gray-200 p-0.5 mr-1">
              <Link
                to={`/profile/details/clients/${client.id}`}
                className="p-2 hover:bg-gray-100 rounded transition"
                onClick={() => setOpenMenuId(null)}
              >
                <Eye className="w-4 h-4 text-gray-600" />
              </Link>
              <Link
                to={`/profile/edit/clients/${client.id}`}
                className="p-2 hover:bg-gray-100 rounded transition"
                onClick={() => setOpenMenuId(null)}
              >
                <Edit className="w-4 h-4 text-gray-600" />
              </Link>
              {canDelete && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onDelete();
                    setOpenMenuId(null);
                  }}
                  className="p-2 hover:bg-red-50 rounded transition text-red-600"
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              )}
            </div>
          )}
          <button
            onClick={(e) => {
              e.stopPropagation();
              setOpenMenuId(openMenuId === client.id ? null : client.id);
            }}
            className="p-1.5 hover:bg-gray-100 rounded transition"
          >
            <MoreHorizontal className="w-4 h-4 text-gray-500" />
          </button>
        </div>
      </td>
    </tr>
  );
}
